var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.293.293a1 1 0 0 1 1.497 1.32l-.083.094-24 24a1 1 0 0 1-1.497-1.32l.083-.094 24-24z",
    fill: "#DE3C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 11.625V13a6.875 6.875 0 0 1-6.188 6.84v2.785h2.126a.687.687 0 1 1 0 1.375h-5.626a.687.687 0 1 1 0-1.375h2.126v-2.784a6.889 6.889 0 0 1-1.475-.313l1.125-1.126A5.5 5.5 0 0 0 18.375 13v-1.14l.892-.891c.28.087.483.348.483.656zm-6.627 5.493 3.87-3.872a4.126 4.126 0 0 1-3.87 3.872zm-6.435-6.18c.38 0 .687.307.687.687V13c0 .43.05.847.142 1.248l-1.104 1.104A6.861 6.861 0 0 1 6 13v-1.375c0-.38.308-.688.688-.688zM8.75 6.125a4.125 4.125 0 0 1 8.076-1.19L8.75 13.013V6.125z",
    fill: "#A9A9A8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.36ffb3dac1e4543c097cdd88f208cffc.svg";
export { ForwardRef as ReactComponent };